import Loadable from 'react-loadable';
import Loading from '../core/Loading';
import Manifest from './Manifest.json';
import PayloadSchema from './PayloadSchema.json';

const ModuleRegistry = {
  manifest: Manifest,
  schema: PayloadSchema,
  layout: Loadable({
    loader: () => import('./DashboardLayout'),
    loading: Loading,
  }),
};
export default ModuleRegistry;
